export default __webpack_public_path__ + "static/media/Boys_1.df7eddd8.svg";